// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    addSearchHistory,
    getSearchHistory,
    SearchHistoryItem,
} from "@insite/client-framework/Services/AutocompleteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import sendSearchTracking from "@insite/client-framework/Store/CommonHandlers/SendSearchTracking";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, AutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import AutocompleteBrands, {
    AutocompleteBrandsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import AutocompleteCategories, {
    AutocompleteCategoriesStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import AutocompleteContent, {
    AutocompleteContentStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteContent";
import AutocompleteProducts, {
    AutocompleteProductsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteProducts";
// import SearchHistory, { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory"; // Bunzl Custom Code
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import Search from "@insite/mobius/Icons/Search"; // Valtech Custom Code
import Popover, {
    ContentBodyProps,
    OverflowWrapperProps,
    PopoverPresentationProps,
    PositionStyle,
} from "@insite/mobius/Popover";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Valtech Custom Code
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

// Valtech Custom Code
import ClockLine from "@store/Library/Components/Icons/Clock/ClockLine";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { ButtonIcon } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import { searchFields } from "@store/Overrides/Widgets/Header/HeaderSearchInput";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Search from "@toolkit/Library/Components/Icons/Search";

/* Bunzl Custom Code - Start */
import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import { getOverFlowWrapperProps } from "@store/Framework/Common/Utilities/dynamicSearchHelpers";
import BunzlAutoCompleteProducts from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProducts";
import SearchHistory, { SearchHistoryStyles } from "@store/Overrides/Widgets/Header/SearchHistory";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
/* Bunzl Custom Code - End */

interface OwnProps {
    /** A unique identifier to assist with id-generation for `aria-controls`. */
    readonly id: string;
    // Valtech Custom Code -->
    searchable: {
        [searchFields.categories]: boolean;
        [searchFields.brands]: boolean;
        [searchFields.contents]: boolean;
        /* Bunzl Custom Code - Start */
        [searchFields.turnOffEnterSearch]: boolean;
        [searchFields.cardStyle]: "elevated" | "outlined";
        /* Bunzl Custom Code - End */
    };
    // <-- Valtech Custom Code
    inputRef?: React.Ref<HTMLInputElement>;
    autocompletePositionFunction?: (element: React.RefObject<HTMLUListElement>) => PositionStyle;
    onBeforeGoToUrl?: () => void;
    extendedStyles?: SearchInputStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    /* Bunzl Custom Code - Start */
    const isAuthenticated = getIsAuthenticated(state);
    const isAddToListModalOpen = state.components.addToListModal.isOpen;
    const { searchWidth, loggedInExtraWidth } = toToolkitApplicationState(state).bunzl.pages.dynamicSearchWidth;
    /* Bunzl Custom Code - End */
    const {
        searchSettings: { autocompleteEnabled, searchHistoryEnabled, searchHistoryLimit, searchPath },
    } = getSettingsCollection(state);
    return {
        autocompleteEnabled,
        searchHistoryEnabled,
        searchHistoryLimit,
        location: getLocation(state),
        searchPath,
        /* Bunzl Custom Code - Start */
        isAuthenticated,
        isAddToListModalOpen,
        searchWidth,
        loggedInExtraWidth,
        /* Bunzl Custom Code - End */
    };
};

const mapDispatchToProps = {
    getAutocompleteModel,
    sendSearchTracking,
};

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

interface State {
    query: string;
    focusableAutocompleteItems: AutocompleteItemModel[];
    focusedAutocompleteItem?: AutocompleteItemModel;
    focusedSearchHistoryQuery?: string;
    autoCompleteModel?: AutocompleteModel;
    isLoading: boolean;
    mobileSearchModalIsOpen: boolean; // Valtech Custom Code
    searchIsFocused: boolean; // Bunzl Custom Code
}

const DOWN_KEY = 40;
const UP_KEY = 38;
const ENTER_KEY = 13;

export interface SearchInputStyles {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteCategoriesStyles?: AutocompleteCategoriesStyles;
    autocompleteBrandsStyles?: AutocompleteBrandsStyles;
    autocompleteContentStyles?: AutocompleteContentStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
    // Valtech Custom Code
    mobileSearchIcon?: IconProps;
    mobileSearchIconWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchModalCloseIcon?: IconProps;
    // Bunzl Custom Code
    leftColumnWrapper?: InjectableCss;
    rightColumnWrapper?: InjectableCss;
}

// Valtech Custom Code
const searchInputGenericHeader = {
    color: "text", // Store Custom Code
    css: css`
        font-size: ${({ theme }) => theme.design.typography.size.large};
        font-weight: ${({ theme }) => theme.design.typography.weight.bold};
    `,
};

const linkAccentStateStyle = {
    color: "primary",
    css: css`
        width: 100%;
        background-color: ${getColor("common.accent")};
    `,
};
// Valtech Custom Code

export const searchInputStyles: SearchInputStyles = {
    // Bunzl Custom Code -->
    leftColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            ${breakpointValues(["100%", "100%", "75%"], "width")}
        `,
    },
    rightColumnWrapper: {
        css: css`
            display: flex;
            ${breakpointValues(["100%", "100%", "20%"], "width")}
            flex-direction: column;
            gap: ${pxToRem(32)};
            flex-wrap: wrap;
        `,
    },
    // <-- Bunzl Custom Code
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            size: 24,
            css: css`
                color: ${getColor("primary")};
            `,
        },
        border: "rectangle",
        cssOverrides: {
            formInputWrapper: css`
                z-index: ${({ theme }) => theme.zIndex.loadingOverlay}; /* Store Custom Code */

                ${IconWrapper} {
                    > * {
                        width: ${pxToRem(24)};
                        height: ${pxToRem(24)};
                    }
                }
            `,
            formField: css`
                width: 100%;
                padding-left: ${x => x.theme.design.layout.spacing.small}; /* Store Custom Code */
                padding-right: ${x => x.theme.design.layout.spacing.small}; /* Store Custom Code */
            `,
            inputSelect: css<any>`
                padding-right: 3em;
                padding-left: ${pxToRem(20)}; /* Store Custom Code */
                ${breakpointValues([null, null, "3em"], "padding-right")}
                border-radius: ${pxToRem(24)}; /* Store Custom Code */
                color: ${getColor("text")}; /* Store Custom Code */

                &:active,
                &:focus {
                    border: ${pxToRem(2)} solid ${getColor("primary")};

                    /* Store Custom Code - Start */
                    border-radius: ${({ theme }) => theme.design.radius.large};
                    padding-left: ${pxToRem(20)};
                    color: ${getColor("text")};

                    /* Store Custom Code - End */
                    ${breakpointValues([null, null, "3em"], "padding-right")}

                    /* Store Custom Code - Start */
                    & + button {
                        background-color: ${getColor("primary")};
                        border-radius: 50%;

                        ${IconWrapper} {
                            color: ${getColor("primary.contrast")};
                        }
                    }

                    /* Store Custom Code - End */
                }
            `,
        },
    },
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            display: inline-flex;
            justify-content: flex-end;
            /* Bunzl Custom Code */
            background: white;
        `,
    },
    popoverContentBody: {
        as: "div",

        _height: "auto", // Bunzl Custom Code

        css: css`
            box-shadow: ${({ theme }) => theme.shadows.main};
            border-radius: ${({ theme }) => theme.design.radius.medium}; /* Store Custom Code */
            padding-top: ${pxToRem(62)}; /* Store Custom Code */
            padding-bottom: ${pxToRem(20)}; /* Bunzl Custom Code */

            overflow: hidden; /* Bunzl Custom Code */
            > * {
                width: 100%;
            }
        `,
    },
    /* Bunzl Custom Code - Start */
    autocompleteWrapper: {
        css: css`
            display: flex;
            width: 100%;
            background: white;
            padding: ${pxToRem(20)};
            padding-top: 0;
            margin-top: ${pxToRem(20)};
            overflow-y: auto;
            max-height: 75vh;
            justify-content: space-between;
            ${breakpointValues(["column", "column", "row"], "flex-direction")};
        `,
    },
    /* Bunzl Custom Code - End */
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            /* Bunzl Custom Code */
            flex-wrap: nowrap;
            width: 100%;
            margin-bottom: ${pxToRem(20)};
        `,
    },
    // Valtech Custom Code
    searchHistoryStyles: {
        headerText: {
            color: "text", // Store Custom Code
            css: css`
                display: flex;
                margin-bottom: ${pxToRem(5)};
                font-size: ${({ theme }) => theme.design.typography.size.large};
            `,
        },
        wrapper: {
            css: css`
                padding: ${pxToRem(20)};
                overflow-x: hidden;
                /* Bunzl Custom Code */
                background: white;
            `,
        },
        itemWrapper: {
            css: css`
                display: flex;
                align-items: center;
                ${contentSpacingStyles(0, 0, pxToRem(5))}

                &:hover, :focus {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        icon: {
            src: ClockLine,
            color: "primary",
            size: 18,
            css: css`
                margin-right: ${pxToRem(10)};
            `,
        },
        link: {
            color: "text", // Store Custom Code
            css: css`
                width: 90%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
            typographyProps: {
                ellipsis: true,
            },
        },
        focusedLink: linkAccentStateStyle,
        clearLink: {
            color: "primary", // Store Custom Code
            css: css`
                &:hover {
                    > ${StyledTypography} {
                        color: ${getColor("secondary")};
                        text-decoration: underline;
                    }
                }
            `,
            typographyProps: {
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.smaller};
                    font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
                `,
            },
        },
    },
    autocompleteCategoriesStyles: {
        headerText: searchInputGenericHeader,
        link: {
            color: "text", // Store Custom Code
            css: css`
                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
        categoryItemText: {
            color: "text.main",
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedCategoryItemText: linkAccentStateStyle,
    },
    autocompleteBrandsStyles: {
        headerText: searchInputGenericHeader,
        link: {
            color: "text", // Store Custom Code
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
        focusedBrandItemText: linkAccentStateStyle,
    },
    autocompleteContentStyles: {
        headerText: searchInputGenericHeader,
        link: {
            /* Bunzl Custom Code */
            color: "text",
            css: css`
                width: 100%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedLink: linkAccentStateStyle,
    },
    autocompleteProductsStyles: {
        headerText: searchInputGenericHeader,
        container: {
            css: css`
                margin: ${pxToRem(5)} 0;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        focusedContainer: {
            css: css`
                margin: ${pxToRem(5)} 0;
                ${linkAccentStateStyle.css}
            `,
        },
        titleLink: {
            color: "text", // Store Custom Code
            css: css`
                width: 100%;
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
                padding: ${pxToRem(16, 0)};
                border-bottom: ${pxToRem(1)} solid ${getColor("common.borderLight")};
            `,
        },
        erpNumberText: {
            color: "text.main",
            css: css`
                margin: 0;
                font-size: ${({ theme }) => theme.design.typography.size.smaller};
            `,
        },
    },
    mobileSearchIconWrapper: {
        css: css`
            display: flex;
            /* Bunzl Custom Code */
            cursor: pointer;
        `,
    },
    mobileSearchIcon: {
        color: "primary",
        size: 28,
        css: css`
            margin-right: 0.5em;
            margin-left: auto;
        `,
    },
    mobileSearchModal: {
        cssOverrides: {
            modalContent: css`
                width: 100%;
                padding: ${pxToRem(20)} ${pxToRem(30)};

                > * {
                    padding: 0;
                }
            `,
        },
        closeButtonProps: {
            css: css`
                &:hover {
                    background-color: ${getColor("common.background")};
                    border-color: ${getColor("common.background")};

                    > ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            `,
        },
    },
};

const styles = searchInputStyles;

class SearchInput extends React.Component<Props, State> {
    private readonly styles: SearchInputStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);

        this.state = {
            query: "",
            focusableAutocompleteItems: [],
            isLoading: false,
            mobileSearchModalIsOpen: false, // Valtech Custom Code
            searchIsFocused: false, // Bunzl Custom Code
        };
    }

    list = React.createRef<HTMLUListElement>();
    popover = React.createRef<HTMLUListElement>();
    addToListModal = React.createRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement | null>;
    showAutocomplete = true;

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // clear the search box on navigate away from search
            if (!this.props.location.pathname.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`)) {
                // TODO ISC-12679 - Redesign so that this can be moved to a field of the class rather than state.
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ query: "" });
            } else {
                this.closeAutocomplete();
            }
        }
        if (this.props.isAddToListModalOpen && !prevProps.isAddToListModalOpen) {
            this.addToListModal.current = document.querySelector("[data-test-selector='productAddToListModal']");
        }
        if (this.state.autoCompleteModel && this.state.autoCompleteModel !== prevState.autoCompleteModel) {
            this.updateFocusableItems();
        }
        if (!this.props.isAddToListModalOpen && prevProps.isAddToListModalOpen && this.state.searchIsFocused) {
            this.focusInput();
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize, true);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.updateFocusableItems();
    };
    /* Bunzl Custom Code - Start */
    focusInput = () => {
        if (this.props.inputRef && "current" in this.props.inputRef) {
            this.props.inputRef.current?.focus();
        }
    };
    /* Bunzl Custom Code - End */
    updateFocusableItems = () => {
        if (this.state.isLoading || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        /* Bunzl Custom Code */
        const isProductsOnTop = true;
        const newFocusableOptions = isProductsOnTop
            ? (products || ([] as AutocompleteItemModel[]))
                  .concat(categories || [])
                  .concat(brands || [])
                  .concat(content || [])
            : (categories || [])
                  .concat(brands || [])
                  .concat(content || [])
                  .concat(products || []);
        this.setState({
            focusableAutocompleteItems: newFocusableOptions,
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    doSearch = () => {
        if (this.state.query.trim() === "") {
            return;
        }

        this.showAutocomplete = false;
        /* Bunzl Custom Code */
        this.setState({
            searchIsFocused: false,
        });
        if (this.state.autoCompleteModel?.products?.length === 1) {
            this.goToUrl(this.state.autoCompleteModel?.products[0].url);
        } else {
            this.goToUrl(`/${this.props.searchPath}?query=${this.state.query}`, false);
        }
        if (this.props.searchHistoryEnabled) {
            addSearchHistory(this.state.query, this.props.searchHistoryLimit);
        }
    };

    loadAutocomplete = debounce((query: string) => {
        this.props.getAutocompleteModel({
            query,
            onSuccess: result => {
                if (this.showAutocomplete) {
                    this.setState({
                        autoCompleteModel: result,
                    });
                    this.openAutocomplete();
                    /* Bunzl Custom Code */
                    if (!this.state.focusableAutocompleteItems.length) {
                        this.updateFocusableItems();
                    }
                }
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    }, 200);

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.showAutocomplete = true;
        const newQuery = event.target.value;
        this.setState({ query: newQuery });
        this.loadAutocomplete(newQuery);
    };

    openAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    closeAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    getPopoverPosition = (element: React.RefObject<HTMLUListElement>) => {
        if (this.props.autocompletePositionFunction) {
            return this.props.autocompletePositionFunction(element);
        }

        const positionStyle: PositionStyle = {
            position: "absolute", // Absolute Custom Code
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            // Valtech Removed Code - Old Positioning
            // Valtech Custom Code
            positionStyle.top = `-${pxToRem(18)}`; // Store Custom Code
            positionStyle.right = 0;
            positionStyle.left = 0;
            // Valtech Custom Code
        }

        return positionStyle;
    };

    moveFocus = throttle((direction: "prev" | "next") => {
        if (this.state.query) {
            this.setState(({ focusedAutocompleteItem, focusableAutocompleteItems }) => {
                const focusableQueue =
                    direction === "prev" ? focusableAutocompleteItems.slice().reverse() : focusableAutocompleteItems;
                const focusedIndex = focusableQueue.indexOf(focusedAutocompleteItem as AutocompleteItemModel);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedAutocompleteItem: newFocusedOption };
            });
        } else {
            this.setState(({ focusedSearchHistoryQuery }) => {
                const searchHistoryItems = getSearchHistory();
                const focusableQueue = direction === "prev" ? searchHistoryItems.slice().reverse() : searchHistoryItems;
                const focusedSearchHistoryItem = focusableQueue.find(o => o.query === focusedSearchHistoryQuery);
                const focusedIndex = focusableQueue.indexOf(focusedSearchHistoryItem as SearchHistoryItem);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedSearchHistoryQuery: newFocusedOption?.query };
            });
        }
    }, 100);

    handlePopoverKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case DOWN_KEY:
                this.moveFocus("next");
                break;
            case UP_KEY:
                this.moveFocus("prev");
                break;
            case ENTER_KEY:
                /* Bunzl Custom Code - Start */
                if (
                    this.props.searchable.turnOffEnterSearch &&
                    !this.state.focusedAutocompleteItem &&
                    !this.state.focusedSearchHistoryQuery
                ) {
                    return;
                }

                if (this.state.focusedAutocompleteItem) {
                    this.goToUrl(this.state.focusedAutocompleteItem.url);
                } else if (this.state.focusedSearchHistoryQuery) {
                    this.handleSearchHistoryChoice(this.state.focusedSearchHistoryQuery);
                } else {
                    this.doSearch();
                }
                /* Bunzl Custom Code - End */
                break;
            default:
                break;
        }
    };

    handlePopoverClose = () => {
        this.setState({
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    trackAutcompleteSearchResults = () => {
        // Make sure only to trigger for autocomplete results
        if (!this.state.query || !this.props.autocompleteEnabled || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        const resultCount =
            (products?.length ?? 0) + (categories?.length || 0) + (content?.length || 0) + (brands?.length || 0);
        if (resultCount > 0) {
            // Track an autocomplete of 1+ items
            this.props.sendSearchTracking({
                searchEvent: "autocompleteSearchResults",
                searchTerm: this.state.query,
                resultCount,
                productCount: products?.length,
                categoryCount: categories?.length,
                contentCount: content?.length,
                brandCount: brands?.length,
            });
            return;
        }

        // Track zero resultCount search results and triggers from this.doSearch
        this.props.sendSearchTracking({
            searchEvent: "searchResults",
            searchTerm: this.state.query,
            resultCount,
        });
    };

    goToUrl = (url: string, track = true) => {
        this.props.onBeforeGoToUrl && this.props.onBeforeGoToUrl();
        if (track) {
            this.trackAutcompleteSearchResults();
        }
        this.closeAutocomplete();
        this.mobileSearchModalCloseHandler(); // Valtech Custom Code
        this.setState({
            // don't use stale results on next search and go to wrong PDP
            autoCompleteModel: undefined,
        });
        this.props.history.push(url);
    };

    /* Bunzl Custom Code */
    mobileSearchInput = this.props.inputRef;

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true });
        // bunzl deleted code, no need to focus on the input as it will have auto focus on mobile.
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };
    /* Bunzl Custom Code - Start */
    handleAutoCompleteSearch = () => {
        this.setState({ searchIsFocused: false });
        this.handlePopoverClose();
        this.doSearch();
    };

    handleFocus = () => {
        this.setState({ searchIsFocused: true });
        if (!this.showAutocomplete) {
            this.showAutocomplete = true;
        }
        if (!this.state.autoCompleteModel && this.state.query) {
            this.loadAutocomplete(this.state.query);
        }
    };
    handleBlur = () => {
        if (!this.props.isAddToListModalOpen) {
            this.setState({ searchIsFocused: false });
        }
    };
    handleSearchHistoryChoice = (query: string) => {
        this.showAutocomplete = true;
        this.setState({ query, autoCompleteModel: undefined });
        this.loadAutocomplete(query);
        this.focusInput();
    };
    /* Bunzl Custom Code - End */
    renderAutocomplete = () => {
        if (!this.props.autocompleteEnabled) {
            return null;
        }

        if (!this.state.autoCompleteModel) {
            return null;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;

        const isSearchable = this.props.searchable; // Valtech Custom Code
        return (
            // Valtech Removed Code - Condition
            // Bunzl Custom Code -->
            <StyledWrapper {...this.styles.autocompleteWrapper} data-test-selector="auto-complete-wrapper">
                <StyledWrapper {...this.styles.leftColumnWrapper}>
                    {products && products.length > 0 && (
                        <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                            <Hidden below="md">
                                <BunzlAutoCompleteProducts
                                    products={products}
                                    handleAutoCompleteSearch={this.handleAutoCompleteSearch}
                                    doSearch={this.doSearch}
                                    variant={this.props.searchable.cardStyle}
                                    goToUrl={this.goToUrl}
                                    isAuthenticated={this.props.isAuthenticated}
                                    focusedItem={this.state.focusedAutocompleteItem}
                                />
                            </Hidden>
                            <Hidden above="sm">
                                <AutocompleteProducts
                                    products={products}
                                    focusedItem={this.state.focusedAutocompleteItem}
                                    goToUrl={this.goToUrl}
                                    extendedStyles={this.styles.autocompleteProductsStyles}
                                />
                            </Hidden>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                {/* Valtech Custom Code */}
                <StyledWrapper
                    css={css`
                        width: 1px;
                        border-left: 1px solid ${getColor("common.border")};
                    `}
                />
                <StyledWrapper {...this.styles.rightColumnWrapper}>
                    {isSearchable.categories && categories && categories.length > 0 && (
                        <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                            <AutocompleteCategories
                                categories={categories}
                                focusedItem={this.state.focusedAutocompleteItem}
                                goToUrl={this.goToUrl}
                                extendedStyles={this.styles.autocompleteCategoriesStyles}
                            />
                        </StyledWrapper>
                    )}
                    {isSearchable.brands && brands && brands.length > 0 && (
                        <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                            <AutocompleteBrands
                                brands={brands}
                                focusedItem={this.state.focusedAutocompleteItem}
                                goToUrl={this.goToUrl}
                                extendedStyles={this.styles.autocompleteBrandsStyles}
                            />
                        </StyledWrapper>
                    )}
                    {isSearchable.contents && content && content.length > 0 && (
                        <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                            <AutocompleteContent
                                content={content}
                                focusedItem={this.state.focusedAutocompleteItem}
                                goToUrl={this.goToUrl}
                                extendedStyles={this.styles.autocompleteContentStyles}
                            />
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                {/* Valtech Custom Code */}
            </StyledWrapper>
        );
        // <-- Bunzl Custom Code
    };

    render() {
        const styles = this.styles;

        const searchId = `headerSearch-${this.props.id}`;
        // Bunzl Custom Code -->
        const loggedInSearchWidth = this.props.searchWidth - this.props.loggedInExtraWidth;
        const widthToUse = this.props.isAuthenticated ? loggedInSearchWidth : this.props.searchWidth;
        const isPopoverOpen = ((this.popover?.current as any)?.state?.open as boolean) || this.state.searchIsFocused;
        const overFlowWrapperProps = getOverFlowWrapperProps(
            isPopoverOpen,
            widthToUse,
            this.props.isAuthenticated,
            this.handleBlur,
            this.handleFocus,
            styles.popoverWrapper?.css,
        );
        // <-- Bunzl Custom Code
        const searchInputProps = {
            ...styles.input,
            ref: this.props.inputRef,
            iconClickableProps: { onClick: this.doSearch },
            value: this.state.query,
            onChange: this.handleInputChange,

            placeholder: translate("Search"),
            // A11Y type for Accessibilty
            type: "search",
            autoComplete: "off",
            className: "search-input",
            clickableText: translate("submit search"),
            id: searchId,
            "data-test-selector": "headerSearchInputTextField",
        };
        /* Bunzl Custom Code.  Ios will not allow you to bring up the keyboard on focus if the input is not rendered when the click event fires, autofocus gets around that.
        The other option is to have an invisible input that is focused on click of the search icon */
        const searchInput = <TextField {...searchInputProps} />;
        const mobileSearchInput = <TextField {...searchInputProps} autoFocus />;

        // <-- Bunzl Custom Code
        return (
            <>
                <VisuallyHidden as="label" htmlFor={searchId} id={`${searchId}-label`}>
                    {translate("Site Search")}
                </VisuallyHidden>
                {/* Valtech Custom Code - Hidden */}
                <Hidden below="sm">
                    <Popover
                        {...styles.popover}
                        controlsId={`${searchId}-popover`}
                        ref={this.popover}
                        insideRefs={[this.list, this.addToListModal]}
                        popoverTrigger={searchInput}
                        positionFunction={this.getPopoverPosition}
                        // bunzl custom code
                        wrapperProps={overFlowWrapperProps}
                        contentBodyProps={
                            {
                                ref: this.list,
                                ...styles.popoverContentBody,
                            } as any
                        }
                        handleKeyDown={this.handlePopoverKeyDown}
                        onClose={this.handlePopoverClose}
                    >
                        {!this.state.query && this.showAutocomplete && (
                            <SearchHistory
                                focusedQuery={this.state.focusedSearchHistoryQuery}
                                goToUrl={this.goToUrl}
                                onClickOverride={this.handleSearchHistoryChoice}
                                extendedStyles={styles.searchHistoryStyles}
                            />
                        )}
                        {this.state.query && this.renderAutocomplete()}
                    </Popover>
                </Hidden>
                {/* Valtech Custom Code - Hidden */}
                {/* Valtech Custom Code */}
                <Hidden above="xs" {...styles.mobileSearchIconWrapper}>
                    <ButtonIcon
                        {...styles.mobileSearchIcon}
                        src={Search}
                        onClick={this.mobileSearchButtonClickHandler}
                    />
                </Hidden>
                <Modal
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    /* Bunzl Custom Code */
                    headline={mobileSearchInput}
                >
                    {!this.state.query && this.showAutocomplete && (
                        <SearchHistory
                            focusedQuery={this.state.focusedSearchHistoryQuery}
                            goToUrl={this.goToUrl}
                            extendedStyles={styles.searchHistoryStyles}
                        />
                    )}
                    {this.state.query && this.renderAutocomplete()}
                </Modal>
                {/* Valtech Custom Code */}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(SearchInput)));
